import React from 'react';

export function FileIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7.5 3.75A2.75 2.75 0 0 0 4.75 6.5v11A2.75 2.75 0 0 0 7.5 20.25h9A2.75 2.75 0 0 0 19.25 17.5V9.23a2 2 0 0 0-.59-1.41l-3.48-3.48a2 2 0 0 0-1.41-.59H7.5Zm6 1.57 3.18 3.18H14a.5.5 0 0 1-.5-.5V5.32ZM8.75 12a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Zm0 3a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Z" />
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M10.5 4.25a6.25 6.25 0 1 0 3.95 11.1l3.1 3.1a.75.75 0 1 0 1.06-1.06l-3.1-3.1a6.25 6.25 0 0 0-5.01-10.04Zm0 1.5a4.75 4.75 0 1 1 0 9.5 4.75 4.75 0 0 1 0-9.5Z" />
    </svg>
  );
}

export function UsersIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9 12.5A3.5 3.5 0 1 0 9 5.5a3.5 3.5 0 0 0 0 7Zm6 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM2.75 18.5A3.75 3.75 0 0 1 6.5 14.75h5A3.75 3.75 0 0 1 15.25 18.5v.75h-12.5v-.75Zm13 .75v-.5a5.2 5.2 0 0 0-1.1-3.2h2.1A3.25 3.25 0 0 1 20 18.8v.45h-4.25Z" />
    </svg>
  );
}

export function DownloadIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3.25a.75.75 0 0 1 .75.75v10.19l2.22-2.22a.75.75 0 1 1 1.06 1.06l-3.53 3.53a.75.75 0 0 1-1.06 0L8.47 12.03a.75.75 0 0 1 1.06-1.06l2.22 2.22V4a.75.75 0 0 1 .75-.75Zm-6.5 14a.75.75 0 0 0-1.5 0v.25A4.25 4.25 0 0 0 8.25 21.75h7.5A4.25 4.25 0 0 0 20 17.5v-.25a.75.75 0 0 0-1.5 0v.25A2.75 2.75 0 0 1 15.75 20h-7.5A2.75 2.75 0 0 1 5.5 17.5v-.25Z" />
    </svg>
  );
}

export function OpenExternalIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8.25 4.75A2.25 2.25 0 0 0 6 7v10A2.25 2.25 0 0 0 8.25 19.25h7.5A2.25 2.25 0 0 0 18 17v-3a.75.75 0 0 0-1.5 0v3a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75V7A.75.75 0 0 1 8.25 6.25H12a.75.75 0 0 0 0-1.5H8.25Zm7.22.97a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06-1.06l2.22-2.22H13a.75.75 0 0 1 0-1.5h4.69l-2.22-2.22a.75.75 0 0 1 0-1.06Z" />
    </svg>
  );
}

export function PaperclipIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8.88 18.88a4.5 4.5 0 0 1 0-6.36l5.3-5.3a3 3 0 1 1 4.24 4.24l-5.3 5.3a1.5 1.5 0 0 1-2.12-2.12l4.95-4.95a.75.75 0 0 0-1.06-1.06l-4.95 4.95a3 3 0 0 0 4.24 4.24l5.3-5.3a4.5 4.5 0 0 0-6.36-6.36l-5.3 5.3a6 6 0 1 0 8.48 8.48l.7-.7a.75.75 0 0 0-1.06-1.06l-.7.7a4.5 4.5 0 0 1-6.36 0Z" />
    </svg>
  );
}

export function TrashIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9 3.75a1.75 1.75 0 0 0-1.75 1.75v.25H4.5a.75.75 0 0 0 0 1.5h.54l.87 11.27A2 2 0 0 0 7.9 20.4h8.2a2 2 0 0 0 1.99-1.88l.87-11.27h.54a.75.75 0 0 0 0-1.5h-2.75V5.5A1.75 1.75 0 0 0 15 3.75H9Zm6.25 2v.25h-6.5V5.5a.25.25 0 0 1 .25-.25h6a.25.25 0 0 1 .25.25Zm-5 4.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Zm3.5.75a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0v-5Z" />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6.72 6.72a.75.75 0 0 1 1.06 0L12 10.94l4.22-4.22a.75.75 0 1 1 1.06 1.06L13.06 12l4.22 4.22a.75.75 0 0 1-1.06 1.06L12 13.06l-4.22 4.22a.75.75 0 0 1-1.06-1.06L10.94 12 6.72 7.78a.75.75 0 0 1 0-1.06Z" />
    </svg>
  );
}

export function ArrowLeftIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M14.78 5.72a.75.75 0 0 1 0 1.06L9.56 12l5.22 5.22a.75.75 0 1 1-1.06 1.06l-5.75-5.75a.75.75 0 0 1 0-1.06l5.75-5.75a.75.75 0 0 1 1.06 0Z" />
    </svg>
  );
}

export function ArrowRightIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9.22 5.72a.75.75 0 0 0 0 1.06L14.44 12l-5.22 5.22a.75.75 0 1 0 1.06 1.06l5.75-5.75a.75.75 0 0 0 0-1.06l-5.75-5.75a.75.75 0 0 0-1.06 0Z" />
    </svg>
  );
}

export function LogoutIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 4.75A2.25 2.25 0 0 0 4.75 7v10A2.25 2.25 0 0 0 7 19.25h4a.75.75 0 0 0 0-1.5H7A.75.75 0 0 1 6.25 17V7A.75.75 0 0 1 7 6.25h4a.75.75 0 0 0 0-1.5H7Zm7.22 3.97a.75.75 0 0 0-1.06 1.06L14.38 11H9a.75.75 0 0 0 0 1.5h5.38l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5a.75.75 0 0 0 0-1.06l-2.5-2.5Z" />
    </svg>
  );
}

export function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3.75a5.75 5.75 0 0 0-5.75 5.75v2.76c0 .96-.35 1.88-1 2.6l-.88.99A1.75 1.75 0 0 0 5.68 18.75h12.64a1.75 1.75 0 0 0 1.31-2.9l-.88-.99a3.92 3.92 0 0 1-1-2.6V9.5A5.75 5.75 0 0 0 12 3.75Zm0 16a2.5 2.5 0 0 0 2.33-1.6.75.75 0 1 0-1.4-.5 1 1 0 0 1-1.86 0 .75.75 0 1 0-1.4.5 2.5 2.5 0 0 0 2.33 1.6Z" />
    </svg>
  );
}
